// gallery
export var HORIZON_GALLERY_HEIGHT = '150px';
export var MOBILE_HORIZON_GALLERY_HEIGHT = '126px';
//
export var SOON_LIVE_TAB_SIZE = 80;
export var SOON_LIVE_TAB_SIZE_MOBILE = 60;
export var SPORT_CARD_WIDTH = 83;
export var MOBILE_SPORT_CARD_WIDTH = 76;
